module.exports = __webpack_public_path__ + "static/img/ux_service.2cc9a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/ux_service.png
// module id = VNGO
// module chunks = 23